import React from "react";
import {
  ResponsiveContainer, AreaChart, Area, XAxis, YAxis,
  Tooltip as RechartsTooltip, ReferenceLine
} from "recharts";

export default function VybesChart({ opened = [], closed = [] }) {
  const haveBoth = Array.isArray(opened) && Array.isArray(closed) && opened.length === closed.length;
  const chartData = haveBoth
    ? opened.map((o, idx) => ({
        date: new Date(o.date).toLocaleDateString("en-US", { month: "short", day: "numeric" }),
        Opened: o.count ?? 0,
        Closed: (closed[idx] && closed[idx].count) ?? 0
      }))
    : [];

  return (
    <div className="vybes-compact-container">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={chartData} margin={{ top: 6, right: 6, bottom: 0, left: 6 }}>
          <defs>
            <linearGradient id="opened" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#1A92FF" stopOpacity={0.35} />
              <stop offset="100%" stopColor="#1A92FF" stopOpacity={0.05} />
            </linearGradient>
            <linearGradient id="closed" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#21b66f" stopOpacity={0.35} />
              <stop offset="100%" stopColor="#21b66f" stopOpacity={0.05} />
            </linearGradient>
          </defs>
          <XAxis dataKey="date" hide />
          <YAxis hide domain={['dataMin', 'dataMax']} />
          <RechartsTooltip
            cursor={{ strokeDasharray: '3 3' }}
            formatter={(value, name) => [value, name]}
            labelFormatter={(label) => label}
            contentStyle={{ borderRadius: 10, border: '1px solid #e9eef3', boxShadow: '0 8px 24px rgba(0,0,0,0.08)' }}
          />
          <ReferenceLine ifOverflow="extendDomain" x={null} stroke="#e3e8ee" />
          <Area type="monotone" dataKey="Opened" stroke="#1A92FF" fill="url(#opened)" strokeWidth={2} dot={false} />
          <Area type="monotone" dataKey="Closed" stroke="#21b66f" fill="url(#closed)" strokeWidth={2} dot={false} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}